import React from "react";
import { Constants } from "../../../common/constants";
import RSVPOptionsForm from "./forms/rsvp_options";
import { SignUpPresetsProp } from "../../../common/sesh_types";
import FadeIn from "../../../src/vendored/FadeIn";
import { FADE_IN_ANIMATION_DURATION } from "./dashboard_utils";

interface SignUpPresetsState {
	intermediate_color: string;
	color: string;
}

export class SignUpOptionsForm extends React.Component<
	SignUpPresetsProp,
	SignUpPresetsState
> {
	constructor(props) {
		super(props);

		let value = props.initial_value
			? props.initial_value
			: Constants.EMBED_COLOR;

		this.state = {
			color: value,
			intermediate_color: value,
		};
	}

	handleChangeDrag(event) {
		this.setState({ intermediate_color: event.hex });
	}

	onClick(event) {
		event.preventDefault();
		event.stopPropagation();
	}

	render() {
		return (
			<FadeIn transitionDuration={FADE_IN_ANIMATION_DURATION}>
				<div
					className="columns is-centered"
					style={{ transition: "opacity 0.5s", opacity: "1" }}
				>
					<div className="column is-three-quarters-tablet is-three-quarters-desktop is-half-widescreen is-two-fifths-fullhd create-event-container">
						<h1 className="title is-3">
							{"Edit Signup Option Presets"}
						</h1>
						<RSVPOptionsForm
							is_premium={this.props.is_premium}
							user_presets={this.props.user_presets}
							user_id={this.props.user_id}
							custom_emojis={this.props.custom_emojis}
							all_guild_data={this.props.all_guild_data}
							updateFunc={() => {}}
							dm_data={this.props.dm_data}
							token_type={this.props.auth_token.token_type}
							access_token={this.props.auth_token.access_token}
						></RSVPOptionsForm>
					</div>
				</div>
			</FadeIn>
		);
	}
}
